import { Pipe, PipeTransform } from '@angular/core';

export interface AssociacaoItem {
  texto: string;     // "Associação (Default)"
  entidade: string;  // "Associação"
  subtipo?: string;  // "Default"
}

@Pipe({ name: 'associacoesParse' })
export class AssociacoesParsePipe implements PipeTransform {
  transform(valor: string | string[] | null | undefined): AssociacaoItem[] {
    if (!valor) return [];
    const partes = Array.isArray(valor) ? valor : valor.split(',')
      .map(p => p.trim())
      .filter(p => p.length > 0);

    return partes.map(p => {
      const m = p.match(/^(.*?)[\s]*\(([^)]+)\)\s*$/); // pega o último "(...)"
      if (m) {
        const entidade = m[1].trim();
        const subtipo = m[2].trim();
        return { texto: p, entidade, subtipo };
      }
      return { texto: p, entidade: p };
    });
  }
}
